import convertServerSide from './convert-server-side'

const handler = (files, epsg, mapType) => convertServerSide(files, `/api/v2/geo/convert/geo-tiff/${mapType}`, epsg)

handler.canHandle = file => /\.(tif|tiff)$/i.test(file.name)

export default handler
